// extracted by css-extract-rspack-plugin
export default {"badge":"header-fragment__common_styles_badge__B3BEW"};